import {
  CURRENT_ROUTE,
  GET_APPLICATION_PAGE_DATA,
  GET_ORDER_SUMMARY_DATA,
  GET_ORDER_SUMMARY_DATA_SUCCESS,
  GET_PROMO_CODE_DETAILS,
  GET_PROMO_CODE_DETAILS_SUCCESS,
  GET_ORDER_SUMMARY_DATA_ERROR,
  GET_USER_STATE,
  GET_USER_DETAILS,
  SET_USER_STATE,
  GET_APPLICATION_LABELS_SUCCESS,
  GET_APPLICATION_PAGE_DATA_SUCCESS,
  SET_GLOBAL_NOTIFICATION_STATUS,
  SET_GLOBAL_ERROR,
  REMOVE_GLOBAL_ERROR,
  HIDE_GLOBAL_ERROR,
  SET_LOADER_STATUS,
  SIGN_OUT,
  LOAD_COUNTRY_DATA,
  LOAD_COUNTRY_DATA_SUCCESS,
  LOAD_COUNTRY_DATA_FAILURE,
  LOAD_SHOPPING_CART_FAILURE,
  LOAD_SHOPPING_CART_DATA,
  LOAD_SHOPPING_CART_DATA_SUCCESS,
  PLACE_ORDER_SUCCESS,
  SET_COUNTRY_STATUS_SUCCESS,
  SET_COUNTRY_STATUS_FAILURE,
  GET_COUNTRY_STATUS,
  SET_SWITCH_ACCOUNT,
  PUNCHOUT_LOGIN,
  GET_PUNCHOUT_SETUP_DETAILS,
  SEARCH_BAR_REQUEST,
  SEARCH_BAR_REQUEST_SUCCESS,
  SEARCH_BAR_SUBMIT,
  SET_EPROC_APP,
  PUNCHOUT_SETUP_FAILURE,
  COUNTRY_CONFIG_SUCCESS,
  ADD_QUOTE_DETAILS,
  ADD_QUOTE_TO_ORDER_ADDRESS_SUCCESS,
  CLEAR_QUOTE_DATA,
  QUOTE_ORDER_SUCCESS,
  RESET_COUPON_ERROR_DATA,
  SYSTEM_NOTIFICATION,
  SYSTEM_NOTIFICATION_SUCCESS,
  SYSTEM_NOTIFICATION_FAILURE,
  SYSTEM_NOTIFICATION_CLOSE,
  LOAD_USER_EMAIL,
  SET_FREIGHT_CHARGE_MODAL_STATUS,
  SUBMIT_FREIGHT_CHARGE_MODAL,
  SHORT_TERM_TOKEN_EXPIRED,
  USER_AUTHORIZATION,
  USER_AUTHORIZATION_SUCCESS,
  SEARCH_BAR_INTERACTION,
  SET_SHIPPING_INFO,
  USER_AUTHENTICATION,
  USER_AUTHENTICATION_CLEAR,
  SET_END_SESSION_MODAL_STATUS,
  UPDATE_PAGE_DATA_WITH_V2NAV_DATA,
  LOAD_EMPTY_CART,
  UPDATE_CUSTOM_PRICING,
  PRODUCT_RECOMMENDATION,
  PRODUCT_RECOMMENDATION_TITLE,
  TRIGGER_ORDER_REVIEW_EVENT,
  SET_ANNOUNCEMENT_DATA,
  CREATE_SETUP_INTENT_ID,
  CREATE_SETUP_INTENT_ID_SUCCESS,
  CREATE_SETUP_INTENT_ID_FAILURE,
  CLEAR_SETUP_INTENT_ID_DATA,
} from '../constants';

// Page-level actions go here
export const pageActions = [];

export const getPageData = () => ({ type: GET_APPLICATION_PAGE_DATA });
export const getCountryStatus = () => ({ type: GET_COUNTRY_STATUS });

export const getUserStatus = () => ({ type: GET_USER_STATE });

export const LoadShoppingCartFailure = error => ({
  type: LOAD_SHOPPING_CART_FAILURE,
  error,
});

export const LoadShoppingCartData = (data = {}) => ({
  type: LOAD_SHOPPING_CART_DATA,
  data,
});

export const LoadShoppingCartDataSuccess = (data = {}, error = null) => ({
  type: LOAD_SHOPPING_CART_DATA_SUCCESS,
  data,
  error,
});

export const systemNotification = () => ({
  type: SYSTEM_NOTIFICATION,
});

export const systemNotificationClose = () => ({
  type: SYSTEM_NOTIFICATION_CLOSE,
});

export const systemNotificationSuccess = (data = {}) => ({
  type: SYSTEM_NOTIFICATION_SUCCESS,
  data,
});

export const systemNotificationFailure = (error = {}) => ({
  type: SYSTEM_NOTIFICATION_FAILURE,
  error,
});

// All default actions go here
export default [getPageData, getCountryStatus];

export const setCurrentRoute = pathname => ({ type: CURRENT_ROUTE, pathname });

export const setApplicationLabels = labels => ({
  type: GET_APPLICATION_LABELS_SUCCESS,
  data: labels,
});

export const setApplicationPageData = pageData => ({
  type: GET_APPLICATION_PAGE_DATA_SUCCESS,
  data: pageData,
});

export const getOrderSummaryData = data => ({
  type: GET_ORDER_SUMMARY_DATA,
  data,
});

export const setOrderSummaryData = data => ({
  type: GET_ORDER_SUMMARY_DATA_SUCCESS,
  data,
});

export const setOrderSummaryDataError = data => ({
  type: GET_ORDER_SUMMARY_DATA_ERROR,
  data,
});

export const getpromoCodeDetails = data => ({
  type: GET_PROMO_CODE_DETAILS,
  data,
});

export const setPromoCodeDetails = data => ({
  type: GET_PROMO_CODE_DETAILS_SUCCESS,
  data,
});

export function setGlobalNotificationStatus(data) {
  return {
    type: SET_GLOBAL_NOTIFICATION_STATUS,
    data,
  };
}

export function setGlobalErrorStatus(data) {
  return {
    type: SET_GLOBAL_ERROR,
    data,
  };
}

export function removeGlobalError(data) {
  return {
    type: REMOVE_GLOBAL_ERROR,
    data,
  };
}

export function setLoaderStatus(status) {
  return {
    type: SET_LOADER_STATUS,
    status,
  };
}

export function hideGlobalErrors() {
  return {
    type: HIDE_GLOBAL_ERROR,
  };
}

export const setUserStatus = userState => ({
  type: SET_USER_STATE,
  userState,
});

export const setUserDetails = userDetails => ({
  type: GET_USER_DETAILS,
  userDetails,
});
export const signOutRequest = data => ({
  type: SIGN_OUT,
  data,
});

export const loadCountryData = () => ({
  type: LOAD_COUNTRY_DATA,
});

export const loadCountryDataSuccess = data => ({
  type: LOAD_COUNTRY_DATA_SUCCESS,
  data,
});

export const loadCountryDataFailure = error => ({
  type: LOAD_COUNTRY_DATA_FAILURE,
  error,
});

export const setCountryStatusSuccess = data => ({
  type: SET_COUNTRY_STATUS_SUCCESS,
  data,
});

export const setCountryStatusFailure = error => ({
  type: SET_COUNTRY_STATUS_FAILURE,
  error,
});

export const placeOrderSuccess = data => ({
  type: PLACE_ORDER_SUCCESS,
  data,
});

export const quoteOrderSuccess = data => ({
  type: QUOTE_ORDER_SUCCESS,
  data,
});

export const setSwitchAccount = (data, onSuccess) => ({
  type: SET_SWITCH_ACCOUNT,
  data,
  onSuccess,
});

export const searchBarRequest = data => ({
  type: SEARCH_BAR_REQUEST,
  data,
});

export const searchBarRequestSuccess = data => ({
  type: SEARCH_BAR_REQUEST_SUCCESS,
  data,
});

export const searchBarSubmit = data => ({
  type: SEARCH_BAR_SUBMIT,
  data,
});

export const searchBarInteraction = data => ({
  type: SEARCH_BAR_INTERACTION,
  data,
});

export const globalPageTransitionActions = [setCurrentRoute, hideGlobalErrors];

export const punchoutLogin = () => ({ type: PUNCHOUT_LOGIN });

export const getPunchoutSetupDetails = () => ({
  type: GET_PUNCHOUT_SETUP_DETAILS,
});

export const setEprocApp = () => ({ type: SET_EPROC_APP });

export const addQuoteDetailsData = data => ({
  type: ADD_QUOTE_DETAILS,
  data,
});

export const addQuoteToOrderAddressSuccess = data => ({
  type: ADD_QUOTE_TO_ORDER_ADDRESS_SUCCESS,
  data,
});

export const clearQuoteData = () => ({
  type: CLEAR_QUOTE_DATA,
  isClearQuote: true,
});
export const eprocGlobalActions = [
  setEprocApp,
  getPunchoutSetupDetails,
  punchoutLogin,
  getPageData,
  getCountryStatus,
];

export const punchoutSetupFailure = data => ({
  type: PUNCHOUT_SETUP_FAILURE,
  data,
});
export const countryConfigSuccess = data => ({
  type: COUNTRY_CONFIG_SUCCESS,
  data,
});
export const resetCouponError = () => ({
  type: RESET_COUPON_ERROR_DATA,
});
export const loadUserEmail = () => ({
  type: LOAD_USER_EMAIL,
});
export const setFreightChargeModalStatus = status => ({
  type: SET_FREIGHT_CHARGE_MODAL_STATUS,
  status,
});
export const shortTermTokenExpired = data => ({
  type: SHORT_TERM_TOKEN_EXPIRED,
  data,
});

export const userAuthorizationAction = data => ({
  type: USER_AUTHORIZATION,
  data,
});

export const userAuthorizationSuccess = data => ({
  type: USER_AUTHORIZATION_SUCCESS,
  data,
});

export const submitFreightChargeModal = data => ({ type: SUBMIT_FREIGHT_CHARGE_MODAL, data });

export const setShippingInfo = data => ({ type: SET_SHIPPING_INFO, data });

export const userAuthentication = data => ({
  type: USER_AUTHENTICATION,
  data,
});

export const userAuthenticationClearData = data => ({
  type: USER_AUTHENTICATION_CLEAR,
  data,
});

export const setEndSessionModalStatus = data => ({
  type: SET_END_SESSION_MODAL_STATUS,
  data,
});

export const updatePageDataWithV2NavData = data => ({
  type: UPDATE_PAGE_DATA_WITH_V2NAV_DATA,
  data,
});
export const loadEmptyCart = () => ({
  type: LOAD_EMPTY_CART,
});

export const updateCustomPricing = data => ({
  type: UPDATE_CUSTOM_PRICING,
  data,
});

export const addProductRecommendation = data => ({
  type: PRODUCT_RECOMMENDATION,
  data,
});
export const productRecommendationTitleClick = data => ({
  type: PRODUCT_RECOMMENDATION_TITLE,
  data,
});

export const triggerOrderReviewEvent = data => ({
  type: TRIGGER_ORDER_REVIEW_EVENT,
  data,
});

export const setAnnouncementData = data => ({
  type: SET_ANNOUNCEMENT_DATA,
  data,
});

export const createSetupIntentId = data => ({
  type: CREATE_SETUP_INTENT_ID,
  data,
});
export const createSetupIntentIdSuccess = data => ({
  type: CREATE_SETUP_INTENT_ID_SUCCESS,
  data,
});
export const clearSetupIntentIdData = data => ({
  type: CLEAR_SETUP_INTENT_ID_DATA,
  data,
});

export const createSetupIntentIdFailure = data => ({
  type: CREATE_SETUP_INTENT_ID_FAILURE,
  data,
});
